{
    "title": "Transactions",
    "charts":{
        "rail": {
            "titleout": "Transfers Out Volume",
            "subtitleout": "Volume of transactions per rail",
            "titlein": "Transfers In Volume",
            "subtitlein": "Volume of transactions per rail"
        },
        "week": {
            "title": "Weekly Volume",
            "subtitle": "Volume of transactions per week"
        },
        "fees":{
            "title": "Fees",
            "subtitle": "Fee volume ($) per fee type in the current period"
        },
        "exchange": {
            "titlebuy": "Exchange Buy Volume",
            "subtitlebuy": "Buy exchange volume in the current period.",
            "titlesell": "Exchange Sell Volume",
            "subtitlesell": "Sell exchange volume in the current period."
        }
    },
    "receipt":{
        "titles": {
            "details": "Transaction Receipt",
            "sourceaccount": "Source Account",
            "beneficiaryinformation": "Beneficiary Information",
            "destinationaccount": "Destination Account",
            "account": "Account",
            "originator": "Originator",
            "fees": "Fee"
        },
        "id": "ID",
        "action": "Action",
        "exchangeRate": "Exchange Rate",
        "exchangeType": "Exchange Type",
        "amountToDebit": "Amount Debited",
        "amountToCredit": "Amount Credited",
        "name": "Name",
        "categoryId": "Category ID",
        "addressLine1": "Address Line 1",
        "addressLine2": "Address Line 2",
        "addressLine3": "Address Line 3",
        "amount": "Amount",
        "transactionId": "Transaction ID",
        "city": "City",
        "state": "State",
        "countryCode": "Country",
        "unitNumber": "Unit Number",
        "postalCode": "Postal Code",
        "accountNumber": "Account Number",
        "routingNumber": "Routing Number",
        "iban": "IBAN",
        "swiftBic": "SWIFT/BIC",
        "institutionName": "Institution Name",
        "status": "Status",
        "type": "Type",
        "transactionStatus": "Transaction Status",
        "createdAt": "Date",
        "assetTypeId": "Asset Type",
        "rail": "Rail",
        "originatorType": "Originator Type",
        "value": "Value"
    }
}